import React from 'react'
import {Container} from 'reactstrap'
//import logonissan from '../Assets/logonissan.svg'
//import classes from '../Containers/Container.module.css'
function Header(props) {
 
//   const headerStyle={

//     height: "80px",
//     width:"700px",
//     textAlign: "center",
//     backgroundImage: `url(${Background})`,
//     fontSize: "30px"
// }
// const logoStyle= {
//   height: "70px"
// }

const headerStyle= {
  //display: "flex",
  height: "50px",
  textAlign: "left",
  margin:"auto",
  justifyContent: "center",
  borderBottom: "solid",
  borderBottomColor:"#1ab394",
  color:props.color

 }
 
  return (
        <Container>
        <header style={headerStyle}>
            <h3>{props.title}</h3>
        </header>
        </Container>
    )
}

export default Header
